
export class TransactionLogRefresh {
  static readonly type = '[TransactionLog] RefreshBySN';
  constructor(public serialNo: string) { }
}
